import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'pagination',
  element: 'link'
});
export var PaginationLink = function PaginationLink(_ref) {
  var to = _ref.to,
      current = _ref.current,
      children = _ref.children;
  var isChildNonNumeric = children.props.children === '...';
  return isChildNonNumeric ? children : _jsx("a", {
    href: "".concat(to),
    sx: {
      variant: variantPath(current ? 'current' : 'base'),
      ':hover, ._force-hover &': {
        variant: variantPath('hover')
      },
      ':focus, ._force-focus &': {
        variant: variantPath('focus')
      }
    },
    children: children
  });
};
PaginationLink.propTypes = {
  to: PropTypes.string,
  current: PropTypes.bool
};
PaginationLink.defaultProps = {
  current: false
};
PaginationLink.displayName = 'PaginationLink';